import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const publications = [
  {
    title: "Indice harmonisé à la production (IHPI)",
    date: "15 février, mai, août et novembre",
    description: "Indice mesurant l'évolution de la production harmonisée dans les différents secteurs."
  },
  {
    title: "Indice du commerce extérieur (ICE)",
    date: "15 février, mai, août et novembre",
    description: "Mesure de l'évolution du commerce extérieur du pays."
  },
  {
    title: "Indice du chiffre d'affaires (ICA)",
    date: "15 février, mai, août et novembre",
    description: "Indicateur de l'évolution des chiffres d'affaires des entreprises."
  },
  {
    title: "Bulletin du commerce extérieur",
    date: "15 février, mai, août et novembre",
    description: "Rapport détaillé sur les activités du commerce extérieur."
  },
  {
    title: "Bulletin de conjoncture",
    date: "15 février, mai, août et novembre",
    description: "Analyse des conditions économiques actuelles du pays."
  },
  {
    title: "Note de conjoncture",
    date: "15 février, mai, août et novembre",
    description: "Résumé des tendances économiques et des prévisions."
  },
  {
    title: "Référentiel (mercuriale) des prix au Burundi",
    date: "15 février, mai, août et novembre",
    description: "Tableau des prix des biens et services sur le marché."
  },
  {
    title: "NewsStat",
    date: "15 février, mai, août et novembre",
    description: "Newsletter des statistiques récentes sur l'économie burundaise."
  },
  {
    title: "Indice des prix à la production agricole",
    date: "15 février, mai, août et novembre",
    description: "Mesure des prix reçus par les producteurs dans le secteur agricole."
  },
  {
    title: "Comptes Nationaux",
    date: "15 février, mai, août et novembre",
    description: "Rapport sur l'ensemble des comptes de l'économie nationale."
  }
];

function PublicationsTrimestrielles() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />

        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>

        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Calendrier de diffusion pour les publications trimestrielles
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Les publications suivantes sont diffusées le 15 février, mai, août et novembre, après 45 jours suivant la fin du trimestre.
        </Typography>

        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>N°</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Titre</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Date de diffusion</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {publications.map((pub, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{pub.title}</TableCell>
                  <TableCell>{pub.description}</TableCell>
                  <TableCell>{pub.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <br />
        <br />
      <Footer />
    </div>
  );
}

export default PublicationsTrimestrielles;